export function formatEur(amount: number, currency: string): string {
    return new Intl.NumberFormat("fr-FR", { style: "currency", currency: currency || "EUR" }).format(amount)
}

export function formatIsoDate(iso: string): string {
    if (!iso) {
        return ""
    }
    const [year, month, day] = iso.split("-")
    return `${day}/${month}/${year}`
}

// Hard-coded months: toLocaleDateString differs between the Node and browser ICU, which breaks hydration
const SHORT_MONTHS = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."]

// The year is only shown when it differs from the current one
export function formatDateRange(startIso: string, endIso: string): string {
    if (!startIso || !endIso) {
        return ""
    }
    const [startYear, startMonth, startDay] = startIso.split("-").map(Number)
    const [endYear, endMonth, endDay] = endIso.split("-").map(Number)
    const currentYear = new Date().getFullYear()
    const yearSuffix = (year: number) => (year === currentYear ? "" : ` ${year}`)

    if (startYear === endYear && startMonth === endMonth) {
        return `${startDay}–${endDay} ${SHORT_MONTHS[startMonth - 1]}${yearSuffix(startYear)}`
    }
    const startYearSuffix = startYear === endYear ? "" : yearSuffix(startYear)
    return `${startDay} ${SHORT_MONTHS[startMonth - 1]}${startYearSuffix} – ${endDay} ${SHORT_MONTHS[endMonth - 1]}${yearSuffix(endYear)}`
}
